module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('c-settings'), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper",
    attrs: {
      "id": "topwrap"
    }
  }, [_c('component-header'), _vm._v(" "), (_vm.set_upgrade_plans) ? _c('section', {
    staticClass: "pricing-style-one",
    staticStyle: {
      "background": "#aa076b",
      "margin-top": "5em"
    },
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-5em"
    }
  }, [(!_vm.set_upgrade_plan_process) ? _c('div', {
    staticClass: "container"
  }, [(_vm.upgradable_plans.length == 0) ? _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("Sorry, no plans to upgrade to.")])]) : _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("Select a plan to upgrade")])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.upgradable_plans), function(plan) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-6 col-sm-12"
    }, [_c('div', {
      staticClass: "single-pricing-one basic-pack"
    }, [_c('div', {
      staticClass: "top-block"
    }, [((plan.product_items && plan.product_items.length > 0)) ? _c('span', {
      staticClass: "price"
    }, [_vm._v("₦" + _vm._s(plan.product_items[0].product_item_price))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pack-name"
    }, [_vm._v(_vm._s(plan.product_name))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })]), _vm._v(" "), (plan.product_url_name == 'plan1') ? _c('ul', {
      staticClass: "feature-lists"
    }, [_c('li', [_vm._v("Extra features")]), _vm._v(" "), _c('li', [_vm._v("Lifetime free support")]), _vm._v(" "), _c('li', [_vm._v("Upgrate options")]), _vm._v(" "), _c('li', [_vm._v("Full access")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "bottom-block"
    }, [_c('p', {
      staticClass: "sp-form-descr"
    }, [_vm._v("Your Upgrade details would be calculated appropriately when you choose plan")]), _vm._v(" "), _c('a', {
      staticClass: "price-btn",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.upgrade_plan(plan)
        }
      }
    }, [_vm._v("Purchase")])])])])
  }))])])]) : _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "10em"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(2)]) : _c('div', {
    staticClass: "row onboarding-wrap"
  }, [(_vm.setup_error_message != '') ? _c('div', {
    staticClass: "row onboarding-head"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "5em",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.setup_error_message) + ".")])])]) : _c('div', [_c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 offset-md-4 onboarding-center"
  }, [_c('div', [_c('h6', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Upgrade Plans")]), _vm._v(" "), (_vm.selected_plan && _vm.selected_plan.product_items) ? _c('h4', [_c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name) + "(₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [_c('div', [_vm._l((_vm.selected_plan.product_items_upgrade_details), function(details) {
    return _c('div', {}, [(_vm.selected_plan_product_service_item.product_item_id == details.subscription_new_product_item_id) ? _c('div', [_c('p', [_vm._v("Your last Subscription was on:"), _c('b', [_vm._v(_vm._s(details.subscription_subscribed_product_start_date))]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("You have "), _c('b', [_vm._v(_vm._s(details.subscription_subscribed_product_days_left))]), _vm._v(" days before your subscription expires.")]), _vm._v(" "), _c('p', [_vm._v("To upgrade to this plan, the total sum to pay is "), _c('b', [_vm._v(_vm._s(details.subscription_new_product_total_amount_to_pay))])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                                Change Subscription Duration\r\n                                                            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                                ")])
  }))]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left gw-btn-cta-light",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedUpgradePlan()
      }
    }
  }, [_vm._v(" Proceed")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    staticStyle: {
      "background": "#f0de3d",
      "cursor": "pointer",
      "color": "#000000"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" Cancel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)])])])])])])])]) : _c('section', {
    staticClass: "home-page-two gw-banner-plain",
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(4)]) : _c('div', {
    staticClass: "row onboarding-wrap"
  }, [(_vm.setup_error_message != '') ? _c('div', {
    staticClass: "row onboarding-head"
  }, [_c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "5em",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#000000",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.setup_error_message) + ".")])])]) : _c('div', [(!_vm.newBusinessForm) ? _c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-6 onboarding-left"
  }, [_c('h6', [_vm._v("Purchase Plans")]), _vm._v(" "), _c('p', [_vm._v("You are about to purchase "), _c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name))]), _vm._v(" plan, this would take few minutes and would lead you to creating and setting up \r\n                                        your "), _c('span', {
    staticClass: "sp-mention-inline"
  }, [_vm._v("Sellpoint")]), _vm._v(" account. We use Sellpoint to manage your acounts. \r\n                                        If you already have a Sellpoint account, you can Sign Up with your details.")]), _vm._v(" "), _c('p', [_c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggleDisplayFeatures
    }
  }, [_vm._v("\r\n                                            See features of " + _vm._s(_vm.selected_plan.product_name) + " "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "color": "#ff0055",
      "font-size": "18px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "features-display",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "seeFeatures"
    }
  }, [_c('div', {
    staticClass: "feature-list"
  }, [(_vm.selected_plan.product_url_name == _vm.plan1.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica1")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan2.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica2")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan3.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica3")])]) : _vm._e()])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"
  }, [_c('div', [_c('h6', {
    staticClass: "gw-mobile",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Purchase Plans")]), _vm._v(" "), (_vm.selected_plan && _vm.selected_plan.product_items) ? _c('h4', [_c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name) + "(₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)) + ")")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {}, [(!_vm.set_up_with_existing_account) ? _c('div', [_c('div', {}, [_c('div', {
    staticClass: "gw-mobile"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-light pu",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('setup-existing', '')
      }
    }
  }, [_vm._v("Sign Up with Sellpoint")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#aa076b",
      "font-size": "14px",
      "font-weight": "500"
    }
  }, [_vm._v("Or Create a Sellpoint account to proceed.")])]), _vm._v(" "), _c('div', {
    staticClass: "gw-not-mobile"
  }, [_c('p', {
    staticClass: "pull-left",
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Create a Sellpoint account to proceed.")]), _vm._v(" "), _c('a', {
    staticClass: "btn gw-btn-cta-light pull-right",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('setup-existing', '')
      }
    }
  }, [_vm._v(" Or Sign Up with Sellpoint")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {}, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Full Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_name),
      expression: "payment_payer_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Your full name"
    },
    domProps: {
      "value": (_vm.payment_payer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_email),
      expression: "payment_payer_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.payment_payer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_phone),
      expression: "payment_payer_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone (format: 09088776655)"
    },
    domProps: {
      "value": (_vm.payment_payer_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.selected_plan_product_service_item.product_item_service_tag) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Subscription Duration: "), _c('b', [_vm._v(_vm._s(_vm.selected_plan_product_service_item.product_item_service_tag))])]), _c('br'), _vm._v(" "), _c('label', [_c('p', {
    staticClass: "sp-form-descr"
  }, [_c('b', [_vm._v("Total to pay: ₦" + _vm._s(_vm.setCurrency(_vm.selected_plan_product_service_item.product_item_price)))])])])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_items && (_vm.selected_plan.product_items.length > 1)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "gw-btn-cta-light",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('display-product_service_items', '')
      }
    }
  }, [_vm._v("\r\n                                                            Change Subscription Duration\r\n                                                        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "border": "#aa076b dashed",
      "margin-top": "6px",
      "padding": "5px"
    },
    attrs: {
      "id": "productServiceItems"
    }
  }, _vm._l((_vm.selected_plan.product_items), function(pt) {
    return _c('div', {
      staticClass: "radio-items"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_service_items_select),
        expression: "product_service_items_select"
      }],
      attrs: {
        "type": "radio",
        "id": pt.product_item_id
      },
      domProps: {
        "value": pt.product_item_id,
        "checked": _vm._q(_vm.product_service_items_select, pt.product_item_id)
      },
      on: {
        "click": function($event) {
          _vm.selectProductServiceItem(pt)
        },
        "__c": function($event) {
          _vm.product_service_items_select = pt.product_item_id
        }
      }
    }), _vm._v(_vm._s(pt.product_item_service_tag) + "\r\n                                                            ")])
  }))]) : _vm._e(), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn pull-left gw-btn-cta-light",
    staticStyle: {
      "cursor": "pointer",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedNewAccount()
      }
    }
  }, [_vm._v(" Proceed")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _c('div', [_vm._m(7), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_password),
      expression: "user.user_password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.user_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sellpoint Username or Handle")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_business),
      expression: "user.user_business"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Sellpoint Username/Handle"
    },
    domProps: {
      "value": (_vm.user.user_business)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_business = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.payment_successful) ? _c('div', {}, [_c('h3', {
    staticStyle: {
      "color": "#7c0b0b",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.payment_successful_message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn gw-btn-cta-light pull-left",
    staticStyle: {
      "cursor": "pointer",
      "border-radius": "2p",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disable_btn
    },
    on: {
      "click": function($event) {
        _vm.proceedWithAccount()
      }
    }
  }, [_vm._v(" Proceed")])])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('hr'), _vm._v(" "), _c('a', {
    staticClass: "gw-btn-cta-light pull-left",
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "1em",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('not-setup-existing', '')
      }
    }
  }, [_vm._v(" Or Create a new account")])])])])])])]) : _c('div', {
    staticClass: "row onboarding-body"
  }, [_c('div', {
    staticClass: "col-6 onboarding-left"
  }, [_c('h6', [_vm._v("Purchase Plans")]), _vm._v(" "), _c('p', [_vm._v("You are about to purchase "), _c('b', [_vm._v(_vm._s(_vm.selected_plan.product_name))]), _vm._v(" plan, this would take few minutes and would lead you to creating and setting up \r\n                                        your "), _c('span', {
    staticClass: "sp-mention-inline"
  }, [_vm._v("Sellpoint")]), _vm._v(" account. We use Sellpoint to manage your acounts. \r\n                                        If you already have a Sellpoint account, you can Sign Up with your details.")]), _vm._v(" "), _c('p', [_c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toggleDisplayFeatures
    }
  }, [_vm._v("\r\n                                            See features of " + _vm._s(_vm.selected_plan.product_name) + " "), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "color": "#ff0055",
      "font-size": "18px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "features-display",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "seeFeatures"
    }
  }, [_c('div', {
    staticClass: "feature-list"
  }, [(_vm.selected_plan.product_url_name == _vm.plan1.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica1")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan2.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica2")])]) : _vm._e(), _vm._v(" "), (_vm.selected_plan.product_url_name == _vm.plan3.product_url_name) ? _c('ul', [_c('li', [_vm._v("cica3")])]) : _vm._e()])]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-12 col-xs-12 col-md-6 onboarding-right"
  }, [_vm._m(10), _vm._v(" "), _c('div', {}, [_c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Name  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Business Username "), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Business Category Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_category_type),
      expression: "business_category_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_category_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Services")])])]), _vm._v(" "), (_vm.business_category_type == 1) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Product Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_product_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.business_category_type == 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select a Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "boarding-messages"
  }, [_c('p', {
    staticStyle: {
      "color": "#4617c7"
    }
  }, [_vm._v(_vm._s(_vm.data_boarding_message))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn gw-btn-cta-light",
    staticStyle: {
      "color": "#ffffff"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.setUpNewAccountBusiness
    }
  }, [_vm._v("Create")])])])])])])])])])])]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "container gw-mobile"
  }, [_vm._m(11)]) : _vm._e()]), _vm._v(" "), (!_vm.$route.query.upgrade) ? _c('section', {
    staticClass: "pricing-style-one gw-mtp",
    attrs: {
      "id": "pricing"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(12), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(13)]) : _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane show active  animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "monthly"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one basic-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan1.product_items && _vm.plan1.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan1.product_items[0].product_item_price))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan1.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan1, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one pro-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan2.product_items && _vm.plan2.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan2.product_items[0].product_item_price) + "/mo")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan2.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan2, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "single-pricing-one biz-pack"
  }, [_c('div', {
    staticClass: "top-block"
  }, [((_vm.plan3.product_items && _vm.plan3.product_items.length > 0)) ? _c('span', {
    staticClass: "price"
  }, [_vm._v("₦" + _vm._s(_vm.plan3.product_items[0].product_item_price) + "/mo")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pack-name"
  }, [_vm._v(_vm._s(_vm.plan3.product_name))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "bottom-block"
  }, [_c('a', {
    staticClass: "price-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.purchase_plan_2(_vm.plan3, 'n')
      }
    }
  }, [_vm._v("Purchase")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane animated fadeInUp",
    attrs: {
      "role": "tabpanel",
      "id": "yearly"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-01",
    attrs: {
      "href": "#pricing"
    }
  }, [_vm._v("Checkout other plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('p', {
    staticClass: "pull-left",
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Proceed with your Sellpoint Account ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-01",
    attrs: {
      "href": "#pricing"
    }
  }, [_vm._v("Checkout other plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-mobile"
  }, [_c('h6', {
    staticClass: "gw-mobile",
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_vm._v("Setup New Sellpoint Account")]), _vm._v(" "), _c('p', {
    staticClass: "sp-form-descr"
  }, [_vm._v("Setup New Sellpoint Account......")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 offset-sm-4",
    staticStyle: {
      "text-align": "center",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticClass: "btn gw-btn-cta-01",
    attrs: {
      "href": "#pricing"
    }
  }, [_vm._v("Checkout other plans")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-title text-center"
  }, [_c('h2', {
    staticStyle: {
      "color": "#aa076b"
    }
  }, [_vm._v("Choose from these plans")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 offset-sm-4"
  }, [_c('div', {
    staticClass: "loading-md"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Max. 2 lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Max. of 5 posts per Lookbook")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Max. 10 Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts per Lookbook")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain")]), _vm._v(" "), _c('li', [_vm._v("*Max Storage Space of 500mb")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "feature-lists"
  }, [_c('li', [_vm._v("Unlimited Lookbooks")]), _vm._v(" "), _c('li', [_vm._v("Unlimited Posts")]), _vm._v(" "), _c('li', [_vm._v("Free .com.ng domain\r\n                                            ")]), _c('li', [_vm._v("Online Store (Functionality)")]), _vm._v(" "), _c('li', [_vm._v("*Max Storage Space of 1Gb")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8539b90"}!./src/pages/Purchase/template.html
// module id = 277
// module chunks = 0